import styled from 'styled-components';
import colors from 'assets/theme/base/colors';

export const NameCellValue = styled.div<{ disabled: boolean }>`
    &:hover {
        color: ${({ disabled }) => disabled ? colors.secondary : colors.primary};
        text-decoration: ${({ disabled }) => disabled ? 'none' : 'underline'};
    }
`;